import WishListItem from "./WishListItem";

export default WishListItem;
